import src from "IMAGE";
export default { src, width: 977, height: 272, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPUlEQVR42iXJywnAIBAAUftvMR0shKDZn+thFDwNw2vaOzp+wp0ZwThv5pgHOYuWpoRdXJnkaVUhInzvwwb6sz3JM4+VMQAAAABJRU5ErkJggg=="};
